import Header from "../components/Header"
import Footer from "../components/local/Footer"
import SessionSteps from "../components/local/SessionSteps"
import Styles from "./start-session.module.scss"
export { getServerSideProps } from "../utils/getServerSideProps"
import RenderOnlyOnClientSide from "../components/RenderOnlyOnClientSide"

function StartSession() {
  return (
    <RenderOnlyOnClientSide>
      <Header mode="voxme" />
      <main className={Styles.Wrapper} id="page-wrap">
        <SessionSteps mode="voxme" />
      </main>
      <Footer mode="voxme" />
    </RenderOnlyOnClientSide>
  )
}

export default StartSession
